import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import alphainnlogo from "./../logo/alphainnlogo.bmp";

const CheckOutReceiptPrint = ({ labelData }) => {
    const headerStyle = {
        backgroundColor: '#1D7874',
        color: '#fff',
        padding: '20px',
        textAlign: 'center',
        fontWeight: 'bold',
    };

    const sectionStyle = {
        padding: '20px',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px',
    };

    const thStyle = {
        // border: '1px solid #ddd',
        border: '1px solid #000',
        padding: '8px',
        backgroundColor: '#f4f4f4',
        textAlign: 'center',
    };

    const tdStyle = {
        // border: '1px solid #ddd',
        border: '1px solid #000',
        padding: '8px',
        textAlign: 'center',
    };

    const thStyle1 = {
        // border: '1px solid #ddd',
        border: '1px solid #FFFFFF',
        padding: '8px',
        backgroundColor: '#f4f4f4',
        textAlign: 'center',
    };

    const tdStyle1 = {
        // border: '1px solid #ddd',
        border: '1px solid #FFFFFF',
        padding: '8px',
        textAlign: 'center',
    };

    
    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return num === 10 ? 'Ten' : teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + units[num % 10] : '');
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + convert(num % 100) : '');
            if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
            if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };


    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    

    if (!labelData) return null;
    const firstItem = labelData;

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    };

    return (
        <div style={{ margin: '10px auto', backgroundColor: '#fff' }}>
            {/* Header Section */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', flexDirection: 'column' }}>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <img
                        src={alphainnlogo}
                        alt="Company Logo"
                        style={{
                            maxHeight: '100px',
                            width: 'auto',
                            height: 'auto',
                            marginBottom: '5px',
                        }}
                    />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <PlaceIcon style={{ color: 'green', width: '30px', height: '30px' }} />
                    <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                        {firstItem.SalePrint.CompanyAddress}
                    </span>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <PhoneIcon style={{ color: 'blue', width: '30px', height: '30px' }} />
                    <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                        {firstItem.SalePrint.CompanyContactNumber}  {firstItem.SalePrint.CompanyEmail}
                    </span>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                        GST No  : {firstItem.SalePrint.GSTNumber}
                    </span>
                </div>
            </div>

            {/* Billing Details */}
            <div style={sectionStyle} >
                <h2 style={{ margintTop: '-2%' }}>Bill To</h2>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-20px' }}>
                    <div>
                        <p><strong>Name:</strong> {labelData.SalePrint.GuestName}</p>
                        <p><strong>Phone Number:</strong> {labelData.SalePrint.GuestContactNumber}</p>
                        <p><strong>Email:</strong>{labelData.SalePrint.GuestEmail}</p>
                        <p><strong>Address:</strong> {labelData.SalePrint.GuestAddress}</p>
                    </div>
                    <div style={{ marginTop: '-1%' }}>
                        <p><strong>Receipt Number:</strong> {labelData.SalePrint.BillNumber}</p>
                        <p><strong>Receipt Date:</strong> {formatDateForInput(labelData.SalePrint.ReceiptDate)}</p>
                        <p><strong>Check In Date:</strong> {formatDateForInput(firstItem.SalePrint.CheckIn)}</p>
                        <p><strong>Check Out Date:</strong>  {formatDateForInput(firstItem.SalePrint.CheckOut)}</p>
                    </div>
                </div>
            </div>

            {/* Payment Details */}
            <div style={{ textAlign: 'center', marginTop: '-2%' }}>
                <h3>
                    INVOICE
                </h3>

            </div>

            {/* Table Section */}
            <table style={{ ...tableStyle, marginTop: '-1%' }}>
                <thead>
                    <tr>
                        <th style={thStyle}>Room Number</th>
                        <th style={thStyle}>Total Stay</th>
                        <th style={thStyle}>Check In </th>
                        <th style={thStyle}>Check Out </th>
                        <th style={thStyle}>Total </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={tdStyle}>{firstItem.SalePrint.RoomName}</td>
                        <td style={tdStyle}>{firstItem.SalePrint.TotalStay}</td>
                        <td style={tdStyle}>{formatDateForInput(firstItem.SalePrint.CheckIn)}  <span style={{ color: 'green' }}>{firstItem.SalePrint.CheckInTime}</span></td>
                        <td style={tdStyle}>{formatDateForInput(firstItem.SalePrint.CheckOut)} <span style={{ color: 'red' }}>{firstItem.SalePrint.CheckOutTime}</span></td>
                        <td style={tdStyle}>{firstItem.SalePrint.BillAmount}</td>
                    </tr>
                </tbody>

                <tbody>
                    <tr>
                        <td colSpan="12" style={{ border: '1px solid #000', padding: '5px' }}>
                            <table style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        {/* Left Side: Receipt Table - Display only if data exists */}
                                        {labelData?.SalePrintItems?.length > 0 ? (
                                            <td style={{ width: '70%', verticalAlign: 'top' }}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr>
                                                            <th style={thStyle}>Bill Date</th>
                                                            <th style={thStyle}>Receipt Type</th>
                                                            <th style={thStyle}>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {labelData?.SalePrintItems.map((record, index) => (
                                                            <tr key={index} style={{ height: '20px' }}>
                                                                <td style={tdStyle}>{formatDateForInput(record.ReceiptDate)}</td>
                                                                <td style={tdStyle}>{record.ReceiptType}</td>
                                                                <td style={tdStyle}>{record.Amount}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </td>
                                        ) :
                                            <td style={{ width: '70%', verticalAlign: 'top' }}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr>
                                                            <th style={thStyle1}></th>
                                                            <th style={thStyle1}></th>
                                                            <th style={thStyle1}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {labelData?.SalePrintItems.map((record, index) => (
                                                            <tr key={index} style={{ height: '20px' }}>
                                                                <td style={tdStyle1}></td>
                                                                <td style={tdStyle1}></td>
                                                                <td style={tdStyle1}></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </td>}

                                        {/* Right Side: Rent Details - Adjust width dynamically */}
                                        <td
                                            style={{
                                                width: labelData?.SalePrintItems?.length > 0 ? '30%' : '100%',
                                                verticalAlign: 'top',
                                                paddingLeft: '10px',
                                            }}
                                            colSpan={labelData?.SalePrintItems?.length === 0 ? 2 : 1} // Span full width if no receipt table
                                        >
                                            <table style={{ width: '100%' }}>
                                                <tbody>
                                                    {[
                                                        { label: 'Room Rent', value: (firstItem?.SalePrint?.RentAmount ?? 0) * (firstItem?.SalePrint?.TotalStay ?? 0) },
                                                        // { label: 'Discount', value: ((  firstItem?.SalePrint?.Discount ?? 0  * ( firstItem?.SalePrint?.TotalStay ?? 0 ) ) + firstItem?.SalePrint?.AdditionalDiscount ?? 0 ) },
                                                        {
                                                            label: 'Discount',
                                                            value: (
                                                                ((firstItem?.SalePrint?.Discount ?? 0) * (firstItem?.SalePrint?.TotalStay ?? 0)) +
                                                                (firstItem?.SalePrint?.AdditionalDiscount ?? 0)
                                                            )
                                                        },

                                                        { label: 'Taxable', value: firstItem?.SalePrint?.TaxableAmount ?? 0 },
                                                        { label: 'CGST', value: firstItem?.SalePrint?.CGSTAmount ?? 0 },
                                                        { label: 'SGST', value: firstItem?.SalePrint?.SGSTAmount ?? 0 },
                                                        // Conditionally include 'Other Amount' only if it's not zero
                                                        ...(firstItem?.SalePrint?.OtherAmount
                                                            ? [{
                                                                label: 'Other Amount',
                                                                value: firstItem?.SalePrint?.OtherAmount
                                                            }]
                                                            : []),
                                                        { label: 'Total', value: (firstItem?.SalePrint?.BillAmount ?? 0) + (firstItem?.SalePrint?.OtherAmount ?? 0) }
                                                    ].map((item, index) => (
                                                        <tr key={index}>
                                                            <td style={{ fontWeight: 'bold', textAlign: 'right', whiteSpace: 'nowrap', paddingRight: '10px' }}>
                                                                {item.label}
                                                            </td>
                                                            <td style={{ fontWeight: 'bold', textAlign: 'center' }}>:</td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                {item.value.toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>


            </table>

            <div style={{ display: "flex", alignItems: "center", gap: "10px"}}>
                <h5>Total Advance Amount Received: <span style={{ fontWeight: "bold" }}>{labelData.SalePrint.AdvanceAmount}</span></h5>
                <h5> <AmountInWords amount={labelData.SalePrint.AdvanceAmount} /> </h5>
            </div>

            {/* Amount in Words */}
            <div style={sectionStyle}>
                <AmountInWords amount={labelData.SalePrint.BillAmount} />
                <p>Payment Mode  : {firstItem.SalePrint.PaymentTypeId === 1 ? "CASH" : firstItem.SalePrint.PaymentTypeId === 2 ? "Cheque" : firstItem.SalePrint.PaymentTypeId === 3 ? "UPI" : "Other"}</p>
            </div>


            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style>

        </div >
    );
};

export default CheckOutReceiptPrint;
